import { IDeleteDiarioObraEquipamentoUseCase } from "../../../presentation/useCases/delete/delete_diario_obras_equipamento_use_case";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";

// DeleteDiarioObraEquipamentoUseCase

export class DeleteDiarioObraEquipamentoUseCase implements IDeleteDiarioObraEquipamentoUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {}

  async deleteDiarioObraEquipamento(IdDiarioObras: number, IdDiarioObrasEquipamentos: number): Promise<void> {
    await this.repository.deleteDiarioObraEquipamento(IdDiarioObras, IdDiarioObrasEquipamentos);
  }
}
